module.exports = __webpack_public_path__ + "static/redditimg-b06cca6db8e1b7739f6576efb86ea02c.png";